import {
    BorderRadiusMedium,
    ColorNeutralGrey3,
    ColorNeutralWhite,
    ColorNordicGrey1,
    FontSize14,
    Spacing16,
    Spacing8
} from 'autogen/design-tokens/tokens';
import type { ProductListPartialViewModel } from 'autogen/swagger/all';
import { invisibleScrollbar } from 'modules/helpers/mixins';
import { memo } from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';

const Container = styled.div`
    display: block;

    ${breakpoint.up(sizes.lg)} {
        display: none;
    }
`;

const OverflowContainer = styled.div``;

const List = styled.ul`
    display: flex;
    padding: 0;
    margin: 0;
    gap: ${Spacing8};
    overflow-y: hidden;
    overflow-x: scroll;
    ${invisibleScrollbar}

    padding: 0 ${Spacing16};
    margin: 0 -${Spacing16};
    scroll-padding-inline-end: ${Spacing16};
    scroll-padding-inline-start: ${Spacing16};
`;

const Item = styled.li<IProps>`
    list-style-type: none;
    border-radius: ${BorderRadiusMedium};
    background-color: ${(props): string => (props.selected ? `${ColorNordicGrey1}` : `${ColorNeutralWhite}`)};

    border-radius: 20px;
    border: 1px solid ${ColorNeutralGrey3};
`;

const Anchor = styled(LinkAction)`
    display: block;
    padding: ${Spacing8} ${Spacing16};
    white-space: nowrap;
    font-size: ${FontSize14};

    &:focus,
    &:active,
    &:hover {
        text-decoration: none;
    }
`;

interface IProps {
    readonly selected: boolean;
}

const ScrollableProductGroups = ({
    model: productGroups
}: {
    model: ProductListPartialViewModel['productGroups'];
}): JSX.Element => {
    const filteredProductGroups = productGroups.filter((productGroup) => !productGroup.hideOnMobile);

    return (
        <Container>
            <OverflowContainer>
                <List>
                    {filteredProductGroups.map((item, index): JSX.Element => {
                        const { selected, name, linkAction } = item;
                        const itemProps = {
                            selected: !!selected
                        };
                        const trackingClass = `tracking_categories_categoryClick_${index + 1}`;
                        return (
                            <Item className="category-item" key={name} {...itemProps}>
                                <Anchor action={linkAction} className={trackingClass}>
                                    {name}
                                </Anchor>
                            </Item>
                        );
                    })}
                </List>
            </OverflowContainer>
        </Container>
    );
};

export default memo(ScrollableProductGroups);
